import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  className = ''
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const priceBlock = document.getElementById('price-block');
      if (priceBlock) {
        priceBlock.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center px-10 py-5 md:px-14 md:py-6 font-sans text-sm md:text-lg font-bold tracking-widest text-white uppercase transition-all duration-300 bg-red-gradient hover:scale-105 focus:outline-none focus:ring-2 focus:ring-patriot-red focus:ring-offset-2 focus:ring-offset-navy-950 overflow-hidden rounded-lg animate-pulse-glow-red shadow-[0_0_20px_rgba(178,34,52,0.4)] hover:shadow-[0_0_40px_rgba(178,34,52,0.7)] ${className}`} aria-label={typeof children === 'string' ? children : 'Call to action button'} data-id="element-42">
      {/* Inner bevel/highlight for 3D premium feel */}
      <span className="absolute inset-0 w-full h-full rounded-lg border-t border-white/30 border-b border-black/30 pointer-events-none" data-id="element-43"></span>

      {/* Continuous Shimmer Effect */}
      <span className="absolute inset-0 w-full h-full bg-red-shimmer opacity-50 animate-shimmer pointer-events-none" data-id="element-44"></span>

      <span className="relative flex items-center gap-3 drop-shadow-md" data-id="element-45">
        {children}
        <ArrowRightIcon className="w-5 h-5 md:w-6 md:h-6 transition-transform duration-300 group-hover:translate-x-2" data-id="element-46" />
      </span>
    </button>;
}